import { IFormFieldCommonProps, IFormFieldProps } from "./FormField"

export const getFormFieldProps = ({
  id,
  label,
  postLabel,
  description,
  error,
  hasError,
  labelProps,
  borderless,
  hasdoublesuffix,
  isViewMode,
  prefix,
  suffix,
}: IFormFieldCommonProps & Pick<IFormFieldProps, "id">): IFormFieldCommonProps => {
  return {
    label,
    postLabel,
    description,

    error,
    hasError,

    labelProps: {
      ...labelProps,
      htmlFor: id,
    },
    hasdoublesuffix,
    borderless,
    isViewMode,

    prefix,
    suffix,
  }
}
